import { Blockchain } from "@rarible/api-client"
import { sepolia } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const sepoliaConfig: StaticEthereumBlockchainConfig = {
  name: "Ethereum",
  icon: "/images/blockchains/ethereum.svg",
  isEvm: true,
  isTestnet: true,
  testnet: true,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://testnet-api.rarible.org",
  basePath: "https://testnet-ethereum-api.rarible.org",
  chainId: 11155111,
  blockchain: Blockchain.ETHEREUM,
  chainName: "Ethereum",
  exchange: {
    v2: "0x3e52D660b69d1bDacb6C513cE085D924F5Cb9c77",
    wrapper: "0x1554aDA53194B961016931A2E86C80D09a816209",
  },
  blockExplorers: [
    {
      url: "https://sepolia.etherscan.io",
      icon: "/images/scanner.svg",
      adress: "https://sepolia.etherscan.io/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "sepolia-ethereum-node",
  transferProxies: {
    nft: "0xA094E566b61b3c2D88ACf7Cc15e3Dd0FA83F32af",
    erc721Lazy: "0xa2eEBb837aEF89369Ad117568d75348e6174520e",
    erc20: "0xB8863180CAC2d0Ab665e5968C0De25298A1D8CEe",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("ETHEREUM:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ether",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("ETHEREUM:0x7b79995e5f793a07bc00c21412e50ecae098e7f9"),
    symbol: "WETH",
    name: "wETH",
    decimals: 18,
  },
  addFundsLink: "",
  hasStabilityProtocol: false,
  viem: sepolia,
}

export const getSepoliaConfig = (): StaticEthereumBlockchainConfig =>
  sepoliaConfig
